<div class="w-[300px] flex flex-col items-end">
  <aside class="flex flex-col fixed top-0 h-100 w-full gap-3">
    <div class="border-bottom">
      <div class="sidebar-container px-2 py-4">
        <a
          routerLink="/"
          class="d-flex gap-2 align-items-center fs-4 text-body">
          <img alt="WeDaVinci" src="/assets/images/logo-green.png" width="40" />
          <p class="m-0">
            <strong>We</strong>
            <span>DaVinci</span>
          </p>
        </a>
      </div>
    </div>

    <div class="sidebar-container px-2">
      <searchbar></searchbar>
    </div>

    <div class="sidebar-container px-2">
      @if (featureFlags.projectCreation.fastProjectCreation) {
        <p-tieredmenu [model]="createProjectMenuModel" />
      } @else {
        <a
          class="btn btn-primary d-flex justify-content-center align-items-center gap-2 w-100"
          routerLink="/topics"
          [queryParams]="{ newIdea: true }">
          <i class="fa fa-plus"></i>
          <span>Create project</span>
        </a>
      }
    </div>

    <nav
      class="sidebar-nav sidebar-container d-flex flex-column gap-3 px-2 flex-nowrap overflow-hidden">
      <div class="d-flex flex-column gap-1">
        <a
          class="sidebar-nav-item"
          routerLink="/overview"
          routerLinkActive="active">
          Overview
        </a>

        <ng-container *ngIf="auth.isAdmin">
          <a
            class="sidebar-nav-item"
            routerLink="/admin"
            routerLinkActive="active">
            Admin
          </a>
          <a
            class="sidebar-nav-item"
            routerLink="/explore"
            routerLinkActive="active">
            Insight
          </a>
          <a
            class="sidebar-nav-item"
            routerLink="/topicviz"
            routerLinkActive="active">
            Explore
          </a>
        </ng-container>

        @if (defaultTopic) {
          <a
            class="sidebar-nav-item"
            routerLink="/topics/{{ defaultTopic._id }}"
            routerLinkActive="active">
            {{ defaultTopic.config.title }}
          </a>
        }
      </div>

      <div class="d-flex flex-column gap-1 flex-nowrap overflow-hidden">
        <h6 class="fs-6 fw-bolder text-body-tertiary">Topics</h6>

        <div class="d-flex flex-column gap-1 overflow-auto">
          <div class="sidebar-nav-item" routerLinkActive="active">
            <button class="btn btn-sm" (click)="toggleTopicsCollapse()">
              <i
                class="fa"
                [class.fa-chevron-right]="isTopicsCollapsed"
                [class.fa-chevron-down]="!isTopicsCollapsed"></i>
            </button>
            <a routerLink="/topics" class="flex-grow-1">Topics Home</a>
            <a class="btn btn-sm" routerLink="/topic/new">
              <i class="fa fa-plus"></i>
            </a>
          </div>

          <div
            [(ngbCollapse)]="isTopicsCollapsed"
            [animation]="false"
            class="sidebar-collapse">
            <div class="d-flex flex-column gap-1">
              <ng-container *ngFor="let topic of topics">
                <div class="sidebar-nav-item" routerLinkActive="active">
                  <button
                    class="btn btn-sm"
                    (click)="
                      topic.isCollapsed = topic.data.ideas.length
                        ? !topic.isCollapsed
                        : true
                    ">
                    <i
                      class="fa"
                      [class.fa-chevron-right]="topic.isCollapsed"
                      [class.fa-chevron-down]="!topic.isCollapsed"></i>
                  </button>
                  <a [routerLink]="['/topics', topic._id]" class="flex-grow-1">
                    {{ topic.config.title }}
                  </a>

                  <!-- <div ngbDropdown container="body">
                <button class="btn btn-sm ms-auto" ngbDropdownToggle>
                  <i class="fa fa-plus"></i>
                </button>

                <div ngbDropdownMenu>
                  <button ngbDropdownItem>Subject podcast</button>
                  <button ngbDropdownItem>Main text artictle</button>
                  <button ngbDropdownItem>Sources article</button>
                </div>
              </div> -->
                </div>
                <div
                  [(ngbCollapse)]="topic.isCollapsed"
                  [animation]="false"
                  class="sidebar-collapse">
                  <div class="d-flex flex-column gap-1">
                    @for (idea of topic.data.ideas; track $index) {
                      <div class="sidebar-nav-item" routerLinkActive="active">
                        <a
                          routerLink="/topics/{{ topic._id }}/ideas/{{
                            idea._id
                          }}">
                          <i class="fa fa-lightbulb"></i>
                          {{ idea.title }}
                        </a>
                      </div>
                    }
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          @if (publishedProjects.length) {
            <div class="sidebar-nav-item">
              <button
                class="btn btn-sm"
                (click)="isRecentCollapsed = !isRecentCollapsed">
                <i
                  class="fa"
                  [class.fa-chevron-right]="isRecentCollapsed"
                  [class.fa-chevron-down]="!isRecentCollapsed"></i>
              </button>
              <span class="flex-grow-1">Shared</span>
            </div>
            <div
              [(ngbCollapse)]="isRecentCollapsed"
              [animation]="false"
              class="sidebar-collapse">
              <div class="d-flex flex-column gap-1">
                @for (project of publishedProjects; track $index) {
                  <div class="sidebar-nav-item" routerLinkActive="active">
                    <a
                      routerLink="/topics/{{ project.topicId }}/ideas/{{
                        project.idea._id
                      }}">
                      <i class="fa fa-lightbulb"></i>
                      {{ project.idea.title }}
                    </a>
                  </div>
                }
              </div>
            </div>
          }

          @if (unpublishedProjects.length) {
            <div class="sidebar-nav-item">
              <button
                class="btn btn-sm"
                (click)="isRecentCollapsed = !isRecentCollapsed">
                <i
                  class="fa"
                  [class.fa-chevron-right]="isRecentCollapsed"
                  [class.fa-chevron-down]="!isRecentCollapsed"></i>
              </button>
              <span class="flex-grow-1">Private</span>
            </div>
            <div
              [(ngbCollapse)]="isRecentCollapsed"
              [animation]="false"
              class="sidebar-collapse">
              <div class="d-flex flex-column gap-1">
                @for (project of unpublishedProjects; track $index) {
                  <div class="sidebar-nav-item" routerLinkActive="active">
                    <a
                      routerLink="/topics/{{ project.topicId }}/ideas/{{
                        project.idea._id
                      }}">
                      <i class="fa fa-lightbulb"></i>
                      {{ project.idea.title }}
                    </a>
                  </div>
                }
              </div>
            </div>
          }

          @if (followedProjects.length) {
            <div class="sidebar-nav-item">
              <button
                class="btn btn-sm"
                (click)="isFollowedCollapsed = !isFollowedCollapsed">
                <i
                  class="fa"
                  [class.fa-chevron-right]="isFollowedCollapsed"
                  [class.fa-chevron-down]="!isFollowedCollapsed"></i>
              </button>
              <span class="flex-grow-1">Followed</span>
            </div>
            <div
              [(ngbCollapse)]="isFollowedCollapsed"
              [animation]="false"
              class="sidebar-collapse">
              <div class="d-flex flex-column gap-1">
                @for (project of followedProjects; track $index) {
                  <div class="sidebar-nav-item" routerLinkActive="active">
                    <a
                      routerLink="/topics/{{ project.topicId }}/ideas/{{
                        project.idea._id
                      }}">
                      <i class="fa fa-lightbulb"></i>
                      {{ project.idea.title }}
                    </a>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </nav>

    <div class="d-flex flex-column gap-3 mt-auto">
      <nav class="sidebar-nav sidebar-container d-flex flex-column px-2">
        <app-notification-center></app-notification-center>
      </nav>
      @if (currentUser) {
        <div class="border-top bg-body-secondary">
          <div
            class="sidebar-container d-flex align-items-center gap-3 px-2 py-3">
            <profile-picture></profile-picture>
            <div>
              {{ currentUser.first_name || currentUser.name }}
            </div>
            <div ngbDropdown container="body" class="ms-auto">
              <button class="btn" ngbDropdownToggle>
                <i class="fa fa-user-cog"></i>
              </button>

              <div ngbDropdownMenu>
                <a
                  class="dropdown-item text-dark"
                  routerLink="/profile"
                  ngbDropdownItem>
                  Profile
                </a>
                <a
                  class="dropdown-item text-dark"
                  routerLink="/change-password"
                  ngbDropdownItem>
                  Change Password
                </a>
                <a
                  class="dropdown-item text-dark cursor-pointer"
                  ngbDropdownItem
                  (click)="requestLogout()">
                  Logout
                </a>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </aside>
</div>
